import { HeurekaWidgetOptions } from '~/types/components/Heureka/HeurekaWidgetOptions';

export function loadHeurekaWidget(options: HeurekaWidgetOptions): void {
  if (typeof window === 'undefined' || window._hwq) {
    return;
  }

  const { setKey, pushParams, scriptSrc } = options;

  window._hwq = window._hwq || [];
  window._hwq.push(['setKey', setKey]);
  window._hwq.push(pushParams);

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = scriptSrc;

  document.head.appendChild(script);
}
